import info from "@constants/branding";

const contacts = [
  { value: "+1-101-763-0175", type: "Phone", icon: "phone" },
  { value: `info@${info.domain}`, type: "Mail", icon: "mail" },
  { value: "Worldwide", type: "Location", icon: "map" },
];

export default contacts;
